import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=e39f7304&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=ts&"
export * from "./welcome.vue?vue&type=script&lang=ts&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=e39f7304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f7304",
  null
  
)

export default component.exports